const MapGetters = {
    NOME_MODULO: "auth",
    ID: "id",
    NOME: "nome",
    EMAIL: "email",
    STATUS: "status"
};

const MapGettersModule = {
    ID: MapGetters.NOME_MODULO + "/" + MapGetters.ID,
    NOME: MapGetters.NOME_MODULO + "/" + MapGetters.NOME,
    EMAIL: MapGetters.NOME_MODULO + "/" + MapGetters.EMAIL,
    STATUS: MapGetters.NOME_MODULO + "/" + MapGetters.STATUS,
};

Object.freeze(MapGetters);
Object.freeze(MapGettersModule);

export {MapGetters, MapGettersModule};
